import React from "react";
import { Container, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./index.scss";
import Header from "../../appLayout/header";

const UpdateSection = () => {
  const { t } = useTranslation();

  return (
    <section className="update-section">
      <Header stylebg={"bg-color"} />
      <div className="d-flex justify-content-center align-items-center h-100 w-100">
        <div className="update-card text-center">
          <h2 className="update-title">
            {t("update.stay")} <span>{t("update.upToDate")}</span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default UpdateSection;
